export default __webpack_public_path__ + "static/media/Shoes8.18cd969c.png";